import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=744555e2&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=744555e2&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=2&id=744555e2&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744555e2"]])

export default __exports__